// extracted by mini-css-extract-plugin
module.exports = {"vector":"styles_vector__2SoJd","display":"styles_display__28Ist","container":"styles_container__16Osc","interactive":"styles_interactive__3dnh5"};